<template>
  <Modal v-model="thirdPartyLogisticsChannelsModal" :title="$t('key1007120')" width="1000" class-name="commonModalStyles"
    :transfer="false" :mask-closable="false" @on-visible-change="thirdPartyLogisticsChannelsChange">
    <!--基本信息-->
    <Card :bordered="false" dis-hover>
      <template #title>
        <h2 class="title_box">{{ $t('key1000929') }}</h2>
      </template>
      <Row style="width: 95%">
        <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
          <template v-for="item in multilingualNamesList">
            <template :slot="item.name">
              <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
                <div class="flex align-items-center mt20 ml12">
                  <span class="basic_item">{{ labelRander(item) }}</span>
                  <span>{{ detailsData['carrierShippingMethodName_' + item.code] }}</span>
                </div>
              </Col>
            </template>
          </template>
        </languagesTabs>
        <Divider/>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <div class="flex align-items-center mb20">
            <span class="basic_item">{{ $t('key1005292') }}</span>
            <span>{{ detailsData.carrierShippingMethodCode }}</span>
          </div>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <div class="flex align-items-center mb20">
            <span class="basic_item">{{ $t('key1005295') }}</span>
            <span>{{
                detailsData.logisticsCarrier && detailsData.haulier ?
                  (detailsData.logisticsCarrier || '' + ' > ' + detailsData.haulier) : ''
              }}</span>
          </div>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <div class="flex align-items-center mb20">
            <span class="basic_item">{{ $t('key1007121') }}</span>
            <span>{{ detailsData.minEfficiency }}</span>
            <span> - </span>
            <span>{{ detailsData.maxEfficiency }}</span>
            <span>{{ $t('key1001631') }}</span>
          </div>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <div class="flex align-items-center mb20">
            <span class="basic_item">{{ $t('key1005298') }}</span>
            <span>{{ detailsData.maxLength }}</span>
            <span>*</span>
            <span>{{ detailsData.maxWidth }}</span>
            <span>*</span>
            <span>{{ detailsData.maxHeight }}</span>
          </div>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <div class="flex align-items-center mb20">
            <span class="basic_item">{{ $t('key1007122') }}</span>
            <span>{{ detailsData.minWeight }}</span>
            <span> - </span>
            <span>{{ detailsData.maxWeight }}</span>
          </div>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <div class="flex align-items-center mb20">
            <span class="basic_item">{{ $t('key1005300') }}</span>
            <span>{{ detailsData.maxPerimeter }}</span>
          </div>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <div class="flex align-items-center mb20">
            <span class="basic_item">{{ $t('key1005301') }}</span>
            <span>{{ detailsData.maxDimensionsLength }}</span>
          </div>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <div class="flex align-items-center mb20">
            <span class="basic_item">{{ $t('key1005302') }}</span>
            <span>{{ detailsData.minVolume }}</span>
            <span> - </span>
            <span>{{ detailsData.maxVolume }}</span>
          </div>
        </Col>
      </Row>
    </Card>
    <!--派送范围-->
    <Card :bordered="false" dis-hover>
      <template #title>
        <h2 class="title_box">{{ $t('key1005310') }}</h2>
      </template>
      <Row style="width: 95%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <div class="flex flex-wrap">
            <Tag v-for="item in deliveryRangeList" class="mb10 mr15">{{ item.name }}</Tag>
          </div>
        </Col>
      </Row>
    </Card>
    <!--交货方式-->
    <Card :bordered="false" dis-hover>
      <template #title>
        <h2 class="title_box">{{ $t('key1004023') }}</h2>
      </template>
      <Row style="width: 95%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <div class="flex align-items-center mb20">
            <span>{{ $t('key1005276') }}</span>
            <Select v-model="deliveryMethod" transfer filterable class="width_300">
              <Option v-for="(item, index) in deliveryMethodList" :value="item.value" :key="index">{{ item.name }}</Option>
            </Select>
          </div>
        </Col>
      </Row>
    </Card>
    <template #footer>
      <Button @click="thirdPartyLogisticsChannelsModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="thirdPartyLogisticsChannelsBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>
<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import languagesTabs from "@/components/common/languagesTabs.vue";

export default {
  name: 'thirdPartyLogisticsChannelsModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      thirdPartyLogisticsChannelsModal: false,
      deliveryMethod: 2,
      deliveryMethodList: [
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007118')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007119')},
      ],
      deliveryRangeList: [],
      detailsData: {},
      carrierShippingMethodCode: null
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initThirdPartyLogisticsChannelsData(obj) {
      this.carrierShippingMethodCode = obj.carrierShippingMethodCode;
      this.getDeliveryMethodData(obj.carrierShippingMethodCode);
      this.initMultilingualFields('detailsData', this.detailsData, ['carrierShippingMethodName_']).then(() => {
        this.axios.get(api.get_ymsCarrierShippingMethod_api_queryById + `?merchantShippingMethodId=${obj.shippingMethodId}`,
          {loading: true}).then((response) => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let {carrierShippingMethodPriceModel} = data;
              let obj = this.handleMultilingualFormFields(data, ['carrierShippingMethodName']);
              if (carrierShippingMethodPriceModel && carrierShippingMethodPriceModel.carrierShippingMethodPriceModelZones) {
                const zones = carrierShippingMethodPriceModel.carrierShippingMethodPriceModelZones;
                const hasAllCountries = zones.some(zone => zone.zoneName === '0');
                if (hasAllCountries) {
                  this.deliveryRangeList = [{name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005242')}];
                } else {
                  // 扁平化获取所有国家名称数组
                  this.deliveryRangeList = zones.flatMap(zone => {
                    const countries = zone.carrierShippingMethodPriceModelZoneCountryList || [];
                    return countries.map(country => ({name: country.cnName}));
                  });
                }
              }
              this.detailsData = Object.assign({}, data, obj);
            }
          }
        });
        this.thirdPartyLogisticsChannelsModal = true;
      });
    },
    // 获取交货方式数据
    getDeliveryMethodData(carrierShippingMethodCode) {
      let paramsKeys = 'thirdShippingMethodId_' + carrierShippingMethodCode;
      let query = {
        businessId: this.userInfo.merchantId,
        paramKeys: [paramsKeys]
      };
      this.axios.post(api.post_erpCommonSettingParam_api_queryByUKAndBusinessId, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          const item = data.find(i => i.paramKey === paramsKeys) || {};
          const obj = JSON.parse(item.paramValue || '{}');
          this.deliveryMethod = obj.deliveryType;
        }
      });
    },
    // 确定按钮
    thirdPartyLogisticsChannelsBtn() {
      let paramsKeys = 'thirdShippingMethodId_' + this.carrierShippingMethodCode;
      let paramValue = {deliveryType: this.deliveryMethod};
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: paramsKeys,
          paramValue: JSON.stringify(paramValue),
        }
      ];
      this.axios.post(api.post_erpCommonSettingParam_api_saveSetting, queryList, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
          this.thirdPartyLogisticsChannelsModal = false;
        }
      });
    },
    // 监听弹窗
    thirdPartyLogisticsChannelsChange(value) {
      if (!value) {
        this.deliveryMethod = 2;
        this.carrierShippingMethodCode = null;
      }
    }
  },
  components: {
    languagesTabs
  },
};
</script>

<style lang="less" scoped>
.commonModalStyles /deep/ {
  .ivu-card-head .title_box {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }

  .basic_item {
    color: #333;
    font-weight: 500;
  }
}
</style>